import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/constants';

interface NavigationContextType {
  lastPage: string;
  setLastPage: React.Dispatch<React.SetStateAction<string>>;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const [lastPage, setLastPage] = useState('/');
  const location = useLocation();

  useEffect(() => {
    const excludedRoutes = [ROUTES.ACCESS_FORBIDDEN, ROUTES.ERROR, ROUTES.NO_INTERNET];
    if (!excludedRoutes.includes(location.pathname)) {
      setLastPage(location.pathname);
    }
  }, [location]);

  const contextValue = useMemo(() => ({ lastPage, setLastPage }), [lastPage]);

  return <NavigationContext.Provider value={contextValue}>{children}</NavigationContext.Provider>;
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};
